class HeroSlideshow {
    constructor(element) {
        this.element = element;
        this.swiper = null; // Initialize swiper property
        this.init();

        // Event listener for Shopify block select
        window.addEventListener('shopify:block:select', e => {
            const selectedSlideIndex = +e.target.dataset.index;
            if (this.swiper) {
                this.swiper.slideTo(selectedSlideIndex, 600);
            }
        });
    }

    init() {
        window.addEventListener("load", () => {
            this.mountSlider();
        });
    }

    mountSlider() {
        const swiperContainer = this.element;
        const speed = swiperContainer.dataset.speed ? parseInt(swiperContainer.dataset.speed) : 50;
        const interval = swiperContainer.dataset.interval ? parseInt(swiperContainer.dataset.interval) : 2000;
        const autoplay = swiperContainer.dataset.autoplay === "true";
        const effect = swiperContainer.dataset.effect ? swiperContainer.dataset.effect : "fade";

        const swiperConfig = {
            spaceBetween: 0,
            rewind: false,
            loop: true,
            effect: effect,
            speed: speed,
            pagination: { el: '.swiper-pagination' },
            navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
            on: {
                activeIndexChange: function () { resetAnimations(true); },
                slideChangeTransitionStart: function () { PlayPauseVideos(true); },
                slideChangeTransitionEnd: function () { resetAnimations(true); },
                init: function () { resetAnimations(true); PlayPauseVideos(true); }
            }
        };

        if (autoplay) {
            swiperConfig.autoplay = { delay: interval, disableOnInteraction: false };
        }

        this.swiper = new Swiper(swiperContainer, swiperConfig);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const swipers = document.querySelectorAll('div.mySwiper');
    swipers.forEach(swiper => new HeroSlideshow(swiper));
});

function resetAnimations() {
    let activeSlides = document.querySelectorAll('.swiper-slide--image:not(.swiper-slide-visible .swiper-slide--image)');
    activeSlides.forEach(slide => {
        const img = slide.querySelector('img');
        if (img && getComputedStyle(img).animationPlayState === 'paused') resetAnimation(slide);
    });
}

function resetAnimation(element) {
    let currentClass = getAnimationClass(element);
    if (currentClass) {
        element.classList.remove(currentClass);
        void element.offsetWidth;
        element.classList.add(currentClass);
    }
}

function getAnimationClass(element) {
    const animationClasses = ['image-animation-pan-left','image-animation-pan-right','image-animation-pan-up','image-animation-pan-down','image-animation-zoom-in','image-animation-zoom-out'];
    return animationClasses.find(className => element.classList.contains(className));
}

function PlayPauseVideos() {
    let allVideos = document.querySelectorAll('.swiper-slide--video video');
    allVideos.forEach(video => {
        let slide = video.closest('.swiper-slide');
        let isActiveSlide = slide.classList.contains('swiper-slide-visible') || slide.classList.contains('swiper-slide-active') || slide.classList.contains('swiper-slide-duplicate-active');
        if (isActiveSlide) {
            if (video.paused) video.play();
        } else {
            if (!video.paused) setTimeout(() => video.pause(), 1000);
        }
    });
}

/* CHINAKWE homepage: immediate shopping block beneath hero */
document.addEventListener('DOMContentLoaded', () => {
    if (window.location.pathname !== '/' || document.getElementById('ck-home-shop-new')) return;
    const hero = document.querySelector('.slideshow-section');
    if (!hero) return;

    const style = document.createElement('style');
    style.textContent = `
      #ck-home-shop-new{padding:64px 0 72px;background:var(--color-background,transparent)}
      #ck-home-shop-new .ck-new-inner{width:min(100% - 40px,1400px);margin:0 auto}
      #ck-home-shop-new .ck-new-kicker{display:block;text-align:center;font-size:10px;letter-spacing:.25em;text-transform:uppercase;opacity:.5;margin-bottom:12px}
      #ck-home-shop-new .ck-new-heading{text-align:center;margin:0 0 32px}
      #ck-home-shop-new .ck-new-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:20px}
      #ck-home-shop-new .ck-new-card{display:block;color:inherit;text-decoration:none}
      #ck-home-shop-new .ck-new-card--holding{cursor:default}
      #ck-home-shop-new .ck-new-media{overflow:hidden;background:#f3f1ed}
      #ck-home-shop-new .ck-new-media img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover;transition:transform .45s ease}
      #ck-home-shop-new .ck-new-card:nth-child(2) .ck-new-media img{object-position:center top}
      #ck-home-shop-new .ck-new-card:hover .ck-new-media img{transform:scale(1.015)}
      #ck-home-shop-new .ck-new-card--holding:hover .ck-new-media img{transform:none}
      #ck-home-shop-new .ck-new-copy{text-align:center;padding:18px 12px 0}
      #ck-home-shop-new .ck-new-copy h3{margin:0 0 7px;line-height:1.15}
      #ck-home-shop-new .ck-new-copy p{margin:0 auto 12px;max-width:42ch;opacity:.68;line-height:1.5}
      #ck-home-shop-new .ck-new-cta{display:inline-block;font-size:11px;letter-spacing:.1em;text-transform:uppercase;border-bottom:1px solid currentColor;padding-bottom:3px}
      #ck-home-shop-category{padding:0 0 72px;background:var(--color-background,transparent)}
      #ck-home-shop-category .ck-cat-inner{width:min(100% - 40px,1400px);margin:0 auto}
      #ck-home-shop-category .ck-cat-heading{text-align:center;margin:0 0 24px}
      #ck-home-shop-category .ck-cat-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:14px}
      #ck-home-shop-category .ck-cat-card{display:block;color:inherit;text-decoration:none}
      #ck-home-shop-category .ck-cat-media{overflow:hidden;background:#f3f1ed}
      #ck-home-shop-category .ck-cat-media img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover;transition:transform .4s ease}
      #ck-home-shop-category .ck-cat-card:first-child .ck-cat-media img{object-position:center top}
      #ck-home-shop-category .ck-cat-card:hover .ck-cat-media img{transform:scale(1.02)}
      #ck-home-shop-category .ck-cat-title{text-align:center;margin:12px 0 0;font-size:14px;letter-spacing:.08em;text-transform:uppercase}
      @media(max-width:749px){
        #ck-home-shop-new{padding:42px 0 48px}
        #ck-home-shop-new .ck-new-inner{width:min(100% - 28px,1400px)}
        #ck-home-shop-new .ck-new-heading{margin-bottom:24px}
        #ck-home-shop-new .ck-new-grid{grid-template-columns:1fr;gap:34px}
        #ck-home-shop-new .ck-new-copy{padding-top:14px}
        #ck-home-shop-category{padding:0 0 54px}
        #ck-home-shop-category .ck-cat-inner{width:min(100% - 28px,1400px)}
        #ck-home-shop-category .ck-cat-heading{margin-bottom:18px;font-size:26px}
        #ck-home-shop-category .ck-cat-grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:18px 10px}
        #ck-home-shop-category .ck-cat-title{font-size:12px;margin-top:9px}
      }
    `;
    document.head.appendChild(style);

    const block = document.createElement('section');
    block.id = 'ck-home-shop-new';
    block.setAttribute('aria-label', 'Shop new collections');
    block.innerHTML = `
      <div class="ck-new-inner">
        <span class="ck-new-kicker">CHINAKWE</span>
        <h2 class="h1 ck-new-heading">SHOP NEW</h2>
        <div class="ck-new-grid">
          <div class="ck-new-card ck-new-card--holding" aria-label="CHINAKWE x Tee Max launching 20th Aug">
            <div class="ck-new-media"><img src="https://cdn.shopify.com/s/files/1/0528/9223/7979/files/chinakwe-tee-max-launching-20-aug.jpg?v=1786808802" alt="CHINAKWE Tee Max collaboration launching 20th Aug"></div>
            <div class="ck-new-copy"><h3 class="h2">CHINAKWE × TEE MAX</h3><p>Launching 20th Aug</p></div>
          </div>
          <a class="ck-new-card" href="/collections/carnival-2026">
            <div class="ck-new-media"><img src="https://cdn.shopify.com/s/files/1/0528/9223/7979/collections/chinakwe-carnival-2026-live-life-header.jpg?v=1786745203" alt="CHINAKWE Carnival 2026 Live Life T-shirt campaign"></div>
            <div class="ck-new-copy"><h3 class="h2">CARNIVAL 2026</h3><p>Limited-edition wearable art for Carnival.</p><span class="ck-new-cta">Shop Carnival</span></div>
          </a>
        </div>
      </div>`;

    const categoryBlock = document.createElement('section');
    categoryBlock.id = 'ck-home-shop-category';
    categoryBlock.setAttribute('aria-label', 'Shop by category');
    categoryBlock.innerHTML = `
      <div class="ck-cat-inner"><h2 class="h2 ck-cat-heading">SHOP BY CATEGORY</h2><div class="ck-cat-grid">
        <a class="ck-cat-card" href="/collections/chinakwe-apparel"><div class="ck-cat-media"><img src="https://cdn.shopify.com/s/files/1/0528/9223/7979/files/chinakwe-love-and-living-life-tshirt-female-model_b42c9f99-6737-48bf-9d97-e984d35edf99.jpg?v=1786742653" alt="Female model wearing CHINAKWE Love and Living Life T-shirt"></div><h3 class="ck-cat-title">Clothing</h3></a>
        <a class="ck-cat-card" href="/collections/art-prints"><div class="ck-cat-media"><img src="https://cdn.shopify.com/s/files/1/0528/9223/7979/products/i-cat-be-stung-by-you-framed_1024x1024_2x_a72ebbd7-9cf3-4f47-824d-b41ac67bc74d.jpg?v=1747527943" alt="Current CHINAKWE I Can't Be Stung By You framed art print"></div><h3 class="ck-cat-title">Art Prints</h3></a>
        <a class="ck-cat-card" href="/collections/chinakwe-home-statement-cushions"><div class="ck-cat-media"><img src="https://cdn.shopify.com/s/files/1/0528/9223/7979/files/Intheirmodernparadise_1.jpg?v=1767661222" alt="CHINAKWE Home statement cushions"></div><h3 class="ck-cat-title">Home</h3></a>
        <a class="ck-cat-card" href="/collections/gifts"><div class="ck-cat-media"><img src="https://cdn.shopify.com/s/files/1/0528/9223/7979/collections/IMG_6558.jpg?v=1758540633" alt="CHINAKWE gifts"></div><h3 class="ck-cat-title">Gifts</h3></a>
      </div></div>`;

    const heroWrapper = hero.closest('.shopify-section') || hero;
    heroWrapper.insertAdjacentElement('afterend', block);
    block.insertAdjacentElement('afterend', categoryBlock);
});

/* CHINAKWE homepage: replace Discover More with customer reviews */
document.addEventListener('DOMContentLoaded', () => {
    if (window.location.pathname !== '/' || document.getElementById('ck-home-reviews')) return;

    const discover = Array.from(document.querySelectorAll('.collection-cards-section')).find(section => {
      const heading = section.querySelector('.section-header h2');
      return heading && heading.textContent.trim().toLowerCase() === 'discover more';
    });
    if (!discover) return;

    const style = document.createElement('style');
    style.textContent = `
      #ck-home-reviews{padding:78px 0;background:#f5f1ea !important;color:#303048 !important}
      #ck-home-reviews *{color:#303048 !important}
      #ck-home-reviews .ck-review-inner{width:min(100% - 40px,1400px);margin:0 auto}
      #ck-home-reviews .ck-review-kicker{display:block;text-align:center;font-size:10px;letter-spacing:.24em;text-transform:uppercase;opacity:.62;margin-bottom:12px}
      #ck-home-reviews .ck-review-heading{text-align:center;margin:0 0 12px;color:#303048 !important}
      #ck-home-reviews .ck-review-sub{text-align:center;margin:0 auto 34px;opacity:.72;max-width:52ch;color:#303048 !important}
      #ck-home-reviews .ck-review-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px}
      #ck-home-reviews .ck-review-card{background:#ffffff !important;padding:30px 28px 26px;min-height:250px;display:flex;flex-direction:column;border:1px solid rgba(48,48,72,.12);box-shadow:0 2px 10px rgba(48,48,72,.04)}
      #ck-home-reviews .ck-review-stars{font-size:18px;letter-spacing:.12em;margin-bottom:18px;color:#303048 !important}
      #ck-home-reviews .ck-review-title{font-size:18px;margin:0 0 10px;line-height:1.25;color:#303048 !important}
      #ck-home-reviews .ck-review-text{margin:0 0 22px;line-height:1.6;opacity:.88;flex:1;color:#303048 !important}
      #ck-home-reviews .ck-review-name{font-size:12px;letter-spacing:.08em;text-transform:uppercase;opacity:.72;color:#303048 !important}
      #ck-home-reviews .ck-review-source{text-align:center;margin:26px 0 0;font-size:12px;letter-spacing:.04em;opacity:.68;color:#303048 !important}
      @media(max-width:949px){#ck-home-reviews .ck-review-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}
      @media(max-width:749px){
        #ck-home-reviews{padding:54px 0}
        #ck-home-reviews .ck-review-inner{width:min(100% - 28px,1400px)}
        #ck-home-reviews .ck-review-heading{font-size:28px}
        #ck-home-reviews .ck-review-sub{margin-bottom:24px}
        #ck-home-reviews .ck-review-grid{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;gap:12px;padding-bottom:6px;-webkit-overflow-scrolling:touch}
        #ck-home-reviews .ck-review-card{min-width:86%;scroll-snap-align:start;min-height:260px;padding:26px 22px 22px}
        #ck-home-reviews .ck-review-grid::-webkit-scrollbar{display:none}
      }
    `;
    document.head.appendChild(style);

    const reviews = document.createElement('section');
    reviews.id = 'ck-home-reviews';
    reviews.setAttribute('aria-label', 'Customer reviews');
    reviews.innerHTML = `
      <div class="ck-review-inner">
        <span class="ck-review-kicker">WHAT OUR CUSTOMERS SAY</span>
        <h2 class="h1 ck-review-heading">CUSTOMER REVIEWS</h2>
        <p class="ck-review-sub">Real feedback from CHINAKWE customers.</p>
        <div class="ck-review-grid">
          <article class="ck-review-card"><div class="ck-review-stars" aria-label="5 out of 5 stars">★★★★★</div><h3 class="ck-review-title">Beautiful and vibrant</h3><p class="ck-review-text">“The sweatshirt is beautiful and colors are vibrant. Shipping was fast and overall experience was great. Run don’t walk to get some apparel.”</p><div class="ck-review-name">Cojoware</div></article>
          <article class="ck-review-card"><div class="ck-review-stars" aria-label="5 out of 5 stars">★★★★★</div><h3 class="ck-review-title">Excellent</h3><p class="ck-review-text">“Love the design quality and the colors are fabulous. Quick service and delivery. I have ordered 4 items and very pleased.”</p><div class="ck-review-name">Doreen Walden</div></article>
          <article class="ck-review-card"><div class="ck-review-stars" aria-label="5 out of 5 stars">★★★★★</div><h3 class="ck-review-title">A great gift</h3><p class="ck-review-text">“I bought the item as my sister wanted it for her birthday. The delivery was super quick and the item looked great. She was very happy.”</p><div class="ck-review-name">Bradley Lodge</div></article>
          <article class="ck-review-card"><div class="ck-review-stars" aria-label="5 out of 5 stars">★★★★★</div><h3 class="ck-review-title">Amazing product</h3><p class="ck-review-text">“Lovely communicative staff. Beautiful product, well made and high quality… and the art/creative is exquisite.”</p><div class="ck-review-name">Anthony Acosta</div></article>
          <article class="ck-review-card"><div class="ck-review-stars" aria-label="5 out of 5 stars">★★★★★</div><h3 class="ck-review-title">Quality products, great designs</h3><p class="ck-review-text">“Quality products, prompt service and customer service is a major factor in the purchase of two products.”</p><div class="ck-review-name">Vanroy Williamson</div></article>
          <article class="ck-review-card"><div class="ck-review-stars" aria-label="5 out of 5 stars">★★★★★</div><h3 class="ck-review-title">I love it</h3><p class="ck-review-text">“I love it and will order a few more items and the shipping was soooo quick!”</p><div class="ck-review-name">Pamela</div></article>
        </div>
        <p class="ck-review-source">Reviews collected via Trustpilot</p>
      </div>`;

    const discoverWrapper = discover.closest('.shopify-section') || discover;
    discoverWrapper.replaceWith(reviews);
});
